module.exports = __webpack_public_path__ + "static/media/ciclismo.a3440b3c.webp";